interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

function SectionHeader({ eyebrow, title, desc, align = "left" }: SectionHeaderProps) {
  return (
    <div className={`${align === "center" ? "text-center" : "text-left"}`}>
      <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-400">
        <span className="h-px w-6 bg-primary-500"></span>
        {eyebrow}
        {align === "center" && <span className="h-px w-6 bg-primary-500"></span>}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">{title}</h2>
      {desc && <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-400 md:text-base">{desc}</p>}
    </div>
  );
}

export default SectionHeader;